import { isTrainingKey } from '@sr-test-wizard/shared';

interface Props {
  /** The Jira issue key (e.g. "SR-1234" or "XOT-5678"). */
  keyValue: string;
  /** Optional className appended to the pill (useful for spacing). */
  className?: string;
}

/**
 * Renders a small "Training" pill next to a Jira issue key when the key
 * belongs to the X-prefixed training/dev project family (XOT / XET /
 * XPOR / XPT). Returns null for live-family keys so it can be sprinkled
 * unconditionally next to every key-rendering pill without polluting the
 * layout for live runs.
 *
 * Reuses the existing `.badge.small.purple` style; no CSS changes.
 */
export function TrainingBadge({ keyValue, className }: Props) {
  if (!keyValue || !isTrainingKey(keyValue)) return null;
  const classes = ['badge', 'small', 'purple'];
  if (className) classes.push(className);
  return (
    <span
      className={classes.join(' ')}
      title="This issue belongs to the X-prefixed training/dev project family in Jira (XOT / XET / XPOR / XPT)."
    >
      Training
    </span>
  );
}
